import SelectUserModerator from "./select-user-moderator";

export default SelectUserModerator;